import {
  useMaterialsStockLevelsQuery,
  useStoredMaterialIdsFromHistoryQuery
} from '@domain/material-storage'
import {MaterialType} from '@domain/materials'
import {dataTestId} from '@hconnect/uikit'
import {Box} from '@mui/material'
import {
  usePlanningChartScheduleData,
  usePlanningChartStartEnd
} from '@widgets/planning-schedule-chart'
import React from 'react'

import {StoredMaterial} from './StoredMaterial'

interface SilosGridParams {
  plantCode: string
  materialType?: MaterialType
  onSelectMaterial: (materialId: number) => void
}

const _SilosGridSection: React.FC<SilosGridParams> = ({
  plantCode,
  materialType,
  onSelectMaterial
}) => {
  const {startOfPlan, endOfPlan, endOfChart} = usePlanningChartStartEnd()
  const {scheduleId} = usePlanningChartScheduleData()
  const {data: stockLevelsData} = useMaterialsStockLevelsQuery({
    pointAtTime: endOfChart,
    planRange: [startOfPlan, endOfPlan],
    scheduleId: scheduleId
  })

  const {data: storedMaterialIds} = useStoredMaterialIdsFromHistoryQuery({
    materialType,
    timeFrame: [startOfPlan, endOfPlan]
  })

  if (!storedMaterialIds) {
    throw new Error('BUG: storedMaterialIds should be loaded fore rendering this component')
  }

  return (
    <Box
      sx={{
        mt: 2,
        display: 'grid',
        rowGap: 4,
        columnGap: 6,
        gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))'
      }}
      {...dataTestId('silo_section_content')}
    >
      {storedMaterialIds.map((materialId) => (
        <StoredMaterial
          plantCode={plantCode}
          onClick={() => onSelectMaterial(materialId)}
          sx={{cursor: 'pointer'}}
          key={materialId}
          materialId={materialId}
          stock={stockLevelsData?.[materialId]}
        />
      ))}
    </Box>
  )
}
export const SilosGridSection = React.memo(_SilosGridSection)
SilosGridSection.displayName = 'SilosGridSection'
